import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import ms from '@/utils/msGraphApi'
import sw from '@/utils/sweetAlert'
import config from '@/utils/const'

const provider = new firebase.auth.OAuthProvider('microsoft.com')

/**
 * firebase認証
 */
function signIn () {
  provider.setCustomParameters({prompt: 'consent'})
  if (config.isTeams) {
    firebase.auth().signInWithRedirect(provider)
  } else {
    Vue.swal({
      icon: 'info',
      html: '認証中...<br>ポップアップを確認してください',
      showConfirmButton: false,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Vue.swal.showLoading()
      }
    })
    firebase.auth().signInWithPopup(provider)
      .then((result) => {
        if (result.user) {
          // バージョンアップアラートが表示される場合、表示時間が一瞬になる
          sw.toastAlert('success', 'サインインしました')
          sessionStorage.setItem('accessToken', result.credential.accessToken)
        }
      })
      .catch((error) => {
        console.error(`firebase error-code: ${error.code}`)
        if (error.code === 'auth/popup-blocked') {
          Vue.swal({
            icon: 'error',
            html: 'ポップアップまたはリダイレクトがブロックされている可能性があります<br>ブラウザのポップアップ/リダイレクトブロック設定で許可されているかご確認ください',
            showConfirmButton: false,
            allowOutsideClick: false,
            width: 'auto'
          })
        } else {
          Vue.swal({
            icon: 'error',
            html: `サインイン処理時にエラーが発生しました`,
            showConfirmButton: false,
            allowOutsideClick: false,
            width: 'auto'
          })
        }
      })
  }
}

/**
 * アクセストークンを再取得するために再認証をする
 */
function reAuthenticate () {
  if (config.isTeams) {
    sessionStorage.setItem('isReAuth', 'true')
    firebase.auth().currentUser.reauthenticateWithRedirect(provider)
  } else {
    firebase.auth().currentUser.reauthenticateWithPopup(provider)
      .then((result) => {
        if (result.user) {
          sessionStorage.setItem('isReAuth', 'true')
          sessionStorage.setItem('accessToken', result.credential.accessToken)
          ms.sendMail(localStorage.getItem('mailContent'), sessionStorage.getItem('sendType'))
        }
      })
      .catch((error) => {
        console.error('error:', error)
        Vue.swal({
          icon: 'error',
          html: '送信に失敗しました<br>ネットワーク環境に異常が無いか確認してください'
        })
      })
  }
}

/**
 * リダイレクト認証時にリザルトを受け取る
 */
function getRedirectResult () {
  // クライアントがアプリ版Teamsの場合、リダイレクト認証なのでここでデータを受け取る
  if (!config.isTeams) {
    confirmSendMail()
    return
  }
  // サインイン処理が終わりリダイレクトした時に発火
  firebase.auth().getRedirectResult().then((result) => {
    if (result.user) {
      sw.toastAlert('success', 'サインインしました')
      sessionStorage.setItem('accessToken', result.credential.accessToken)
      // 再認証からのリダイレクトなら
      if (sessionStorage.getItem('isReAuth') === 'true') {
        ms.sendMail(localStorage.getItem('mailContent'), sessionStorage.getItem('sendType'))
      }
      // 送信が失敗した可能性がある時に発火
    } else {
      confirmSendMail()
    }
  })
}

/**
 * メールが失敗していた場合にアラートを出す
 */
function confirmSendMail () {
  const mailContent = JSON.parse(localStorage.getItem('mailContent'))
  if (!mailContent || /勤怠連絡/.test(mailContent.message.subject)) return
  const reSendDate = mailContent.message.subject.match(/[0-9]{4}\/[0-9]{2}\/[0-9]{2}/)
  Vue.swal({
    icon: 'warning',
    html: `前回の投稿に失敗した可能性があります<br>再送しますか？(${reSendDate[0]}送信分)<br><font size="2" color="#828282">※Teamsまたはメーラーを確認してください</font>`,
    confirmButtonText: '再送する',
    cancelButtonText: '再送しない',
    showCancelButton: true,
    allowOutsideClick: false,
    reverseButtons: true
  }).then((result) => {
    if (result.isConfirmed) {
      ms.sendMail(localStorage.getItem('mailContent'), 'reSend')
    } else {
      sessionStorage.removeItem('sendType')
      sessionStorage.removeItem('isReAuth')
      localStorage.removeItem('mailContent')
    }
  })
}

export default {signIn, reAuthenticate, getRedirectResult}



// WEBPACK FOOTER //
// ./src/utils/authentication.js